// extracted by mini-css-extract-plugin
export var gif = "_is-0";